import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ `${ className } ant-spin-dot-spin` } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2 12.02C2 12.02 2 12.01 2 12C2 6.49 6.47 2.01 11.97 2V4C7.57 4.01 4 7.6 4 12C4 12 4 12.01 4 12.02H2ZM20 12.02C20 16.42 16.41 20 12.01 20.01V22.01C17.52 22.01 22 17.53 22 12.02H20Z" fill={ fill || 'currentColor' } />
    </svg>
);
